import { __extends, __rest, __assign } from 'tslib';
import classNames from 'classnames';
import * as React from 'react';
import Button from '../Button/Button.js';
import Gold from '../Gold/Gold.js';
import Icon from '../Icon/Icon.js';
import styles from './ButtonDublon.module.scss.js';

var ButtonDublon = (function (_super) {
    __extends(ButtonDublon, _super);
    function ButtonDublon() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ButtonDublon.prototype.render = function () {
        var _a, _b, _c;
        var _d = this.props, caption = _d.caption, amount = _d.amount, isDiscount = _d.isDiscount, onClick = _d.onClick, className = _d.className, customize = __rest(_d, ["caption", "amount", "isDiscount", "onClick", "className"]);
        var classNameCaption = classNames(styles.caption, (_a = {},
            _a[styles.isDisabled] = !!this.props.isDisabled,
            _a));
        var classNameDublon = classNames(styles.dublon, (_b = {},
            _b[styles.isDisabled] = !!this.props.isDisabled,
            _b));
        var classNameDiscount = classNames(styles.discount, (_c = {},
            _c[styles.isDisabled] = !!this.props.isDisabled,
            _c));
        return (React.createElement(Button, __assign({}, customize, { onClick: onClick || (function () { return null; }), className: classNames(className) }),
            React.createElement("span", { className: classNameCaption }, caption),
            isDiscount ? (React.createElement("span", { className: classNameDiscount },
                React.createElement(Icon, { glyph: "discount" }))) : null,
            React.createElement("span", { className: classNameDublon },
                React.createElement(Gold, { amount: amount }))));
    };
    return ButtonDublon;
}(React.PureComponent));

export { ButtonDublon as default };
//# sourceMappingURL=ButtonDublon.js.map
